import axios from '../http.js'

//考试列表
function getExamList(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/queryExamPage',
    method: 'post',
    data: data
  })
}
//考试成绩列表
function getStudentScoreList(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/queryStudentScorePage',
    method: 'post',
    data: data
  })
}
//复制
function copyExam(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/copyExam',
    method: 'post',
    params: data
  })
}
//新增
function createExam(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/createExam',
    method: 'post',
    data: data
  })
}
//删除
function deleteExam(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/deleteExam',
    method: 'post',
    params: data
  })
}
//编辑认证
function editAuthConfig(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/editAuthConfig',
    method: 'post',
    data: data
  })
}
//编辑考试
function editExam(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/editExam',
    method: 'post',
    data: data
  })
}
//发布/取消发布考试
function publishOrUnPublishExam(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/publishOrUnPublish',
    method: 'post',
    params: data
  })
}

//作废考试
function repealExam(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/repealExam',
    method: 'post',
    params: data
  })
}
//编辑考试
function getExamDetail(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/queryExamDetail',
    method: 'post',
    params: data
  })
}
//考试成绩统计
function queryStudentScoreStatistic(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/queryStudentScoreStatistic',
    method: 'post',
    data: data
  })
}

//试卷详情
function queryUserExamTestPaper(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/queryUserExamTestPaper',
    method: 'post',
    params: data
  })
}
//查看准入证
function queryUserAuth(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/queryUserAuth',
    method: 'post',
    params: data
  })
}
//导出成绩
function exportStudentScore(data) {
  return axios.baseAxios({
    url: '/backstage/examManage/exportStudentScore',
    method: 'get',
    params: data
  })
}

export default {
  getExamList,
  getStudentScoreList,
  copyExam,
  createExam,
  deleteExam,
  editAuthConfig,
  editExam,
  publishOrUnPublishExam,
  getExamDetail,
  repealExam,
  queryStudentScoreStatistic,
  queryUserExamTestPaper,
  queryUserAuth,
  exportStudentScore
}


// WEBPACK FOOTER //
// ./src/api/modules/examCenter.js